import React from 'react';
import { Nav } from 'react-bootstrap';

export default function NavbarItem({ href, title }) {
    return (

        <Nav.Link href={href} className='py-0 fw-normal custom-nav-link text-capitalize'>{title}</Nav.Link>

    )
}
